<div class="card activity-card">
  <div>
    <div class="activity-card__header">
      <svg-icon class="" src="assets/images/icons/news.svg"></svg-icon>
      <h2>{{ "Overview.Header.News" | translate }}</h2>
    </div>
    @if (hasNewsItems()) {
      <ul>
        @for (item of newsItems() | slice: 0 : 2; track $index) {
          <a href="{{ newsUrl }}/{{ currentLang() }}/{{ item | getNewsItemLink }}" class="no-style-link">
            <li class="activity-card__item">
              <span class="activity-card__message" [innerHTML]="item.title"></span>
              <span class="activity-card__time">
                {{ item.publishedAt | date: "d MMMM y" : undefined : currentLang() }}
              </span>
            </li>
          </a>
        }
      </ul>
      <div class="activity-card__footer">
        <a href="{{ newsUrl }}/{{ currentLang() }}">
          <span>{{ "Overview.News.ReadMore" | translate }}</span>
        </a>
      </div>
    } @else {
      <div class="activity-card__empty-state">
        <svg-icon class="activity-card__empty-state--icon" src="assets/images/icons/icon-rocket.svg"></svg-icon>
        <span class="activity-card__empty-state--text">{{ "Overview.News.NoNews" | translate }}</span>
      </div>
    }
  </div>
</div>
